import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HashRouter } from 'react-router-dom'

import { demanderPersistance, enregistrerServiceWorker } from './pwa/register'
import { App } from './ui/App'
import './ui/styles.css'

/**
 * `HashRouter` et non `BrowserRouter`, pour deux raisons qui se renforcent.
 *
 * D'abord, en mode standalone iOS, les URL profondes servies par le serveur
 * sont une source connue d'ecrans blancs au relancement de l'app. Le routage
 * par fragment est entierement gere cote client et supprime le probleme, ainsi
 * que le besoin d'une regle de repli SPA cote Apache.
 *
 * Ensuite et surtout : c'est ce qui permet aux raccourcis de transmettre une
 * nuit **sans que le serveur la voie**. Un fragment n'est jamais envoye dans
 * la requete HTTP ; les heures de sommeil n'apparaissent donc dans aucun log.
 */
async function demarrer() {
  void demanderPersistance()
  enregistrerServiceWorker()

  const racine = document.getElementById('root')
  if (!racine) throw new Error('Element racine introuvable')

  createRoot(racine).render(
    <StrictMode>
      <HashRouter>
        <App />
      </HashRouter>
    </StrictMode>,
  )
}

void demarrer()
